import { useQueryParam } from 'react-resource-router';

import PrivacyFilter from 'src/components/privacy-filter';
import { RepositoryFilters } from 'src/sections/profile/types';
import { ProjectsFilter } from 'src/sections/workspace/components/workspace-filters/projects-filter';
import { WorkspaceProjectFilterContainer } from 'src/sections/workspace/components/workspace-filters/projects-filter-provider';

import * as styles from './filters.styles';
import LanguagesFilter from './languages-filter';
import WatchingFilter from './profile-watching-filter';
import SearchFilter from './search-filter';

export type Props = {
  filters: RepositoryFilters;
  onFilterChange: (filters: RepositoryFilters) => void;
};

export const Filters = (props: Props) => {
  const handleFilterChange = (filter: Partial<RepositoryFilters>): void => {
    const { onFilterChange, filters } = props;
    onFilterChange({ ...filters, ...filter });
  };

  const { search, language, privacy, watching } = props.filters;

  const [projectUuid, setProjectUuid] = useQueryParam('project');
  const [, setPage] = useQueryParam('page');

  const handleProjectChange = (s: any) => {
    setProjectUuid(s);
    // Use `replace` instead of the default `push` to prevent an additional
    // update to the route after a separate query param is updated.
    // For now, `resetPage` should be called only when another query param is
    // modified.
    setPage(undefined, 'replace');
  };

  return (
    <styles.FiltersContainer>
      <styles.SearchContainer>
        <SearchFilter search={search} onFilterChange={handleFilterChange} />
      </styles.SearchContainer>
      <styles.ProjectContainer>
        <WorkspaceProjectFilterContainer>
          <ProjectsFilter
            projectUuid={projectUuid}
            onChange={handleProjectChange}
          />
        </WorkspaceProjectFilterContainer>
      </styles.ProjectContainer>
      <styles.PrivacyFilterContainer>
        <PrivacyFilter onFilterChange={handleFilterChange} privacy={privacy} />
      </styles.PrivacyFilterContainer>
      <styles.LanguagesFilterContainer>
        <LanguagesFilter
          onFilterChange={handleFilterChange}
          selectedLanguage={language || null}
        />
      </styles.LanguagesFilterContainer>
      <WatchingFilter onFilterChange={handleFilterChange} watching={watching} />
    </styles.FiltersContainer>
  );
};

export default Filters;
